var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawProgrammingReKg9V(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1039.69,
    height: 756.171,
    viewBox: "0 0 1039.69 756.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_programming_re_kg9v",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 35.282,
    cy: 35.282,
    r: 35.282,
    transform: "translate(570.335 62.74)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1072,810.282c52.443-39.944,77.49-107.066,61.809-171.1q-.584-2.386-1.234-4.762c-10.4-38.007-36.116-74.13-73.6-86.275-31.475-10.2-65.831-2.356-98.667-6.411-64.459-7.96-114.433-60.115-149.595-114.722S748.522,311.287,701.8,266.174c-77.016-74.361-202.65-90.371-298.139-41.968S247.344,380,249.937,487.023s66.13,209.349,158.4,263.638c33.9,19.944,73.1,34.072,112.117,29.129,33.854-4.29,64.614-22.48,98.309-27.881,52.976-8.491,105.614,15.461,151.435,43.373s90.079,60.995,142.146,73.934C962.9,881.779,1025.539,845.666,1072,810.282Z",
    transform: "translate(-192.684 -153.354)",
    fill: "rgba(0,246,255,0.32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M954.621,236.97c-1.15-.766-2.312-1.493-3.462-2.233A502.441,502.441,0,0,0,845.039,183.3L836.4,302.51H781.613V165.893c-3.449-.714-6.924-1.387-10.4-2.022V302.51h-65.1A135.138,135.138,0,0,1,570.971,167.373h0c-3.489.753-6.951,1.559-10.412,2.418V302.51H507.531L499.3,188.832a503.261,503.261,0,0,0-108.274,57.52c-.581.4-1.163.806-1.731,1.2-2.92,2.048-5.8,4.136-8.668,6.25V708.611h156.28l-2.762-38.254-15.2-210.034H824.967l-15.2,210.034-2.762,38.254H961.559V241.568Q958.11,239.229,954.621,236.97ZM560.559,425.637H516.438l-8.153-112.714h52.274Zm210.655,0h-74.1V423.4a8.166,8.166,0,0,0-8.179-8.166H656.716a8.163,8.163,0,0,0-8.166,8.166v2.233H570.971V312.923H771.213Zm10.4,0V312.923h54.031l-8.153,112.714Z",
    transform: "translate(-150.658 -163.871)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M206.59,598.162a381.916,381.916,0,0,0,37.157,38.254l965.376,1.321a381.856,381.856,0,0,0,37.157-38.254Z",
    transform: "translate(-206.59 -24.298)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M702.02,506.784V620.032a5.448,5.448,0,0,0,5.443,5.443H875.284a5.447,5.447,0,0,0,5.443-5.443V506.784a5.45,5.45,0,0,0-5.443-5.437H707.463A5.45,5.45,0,0,0,702.02,506.784Z",
    transform: "translate(-47.368 -55.412)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M705,507.238V617.679a2.914,2.914,0,0,0,2.908,2.909H872.93a2.914,2.914,0,0,0,2.909-2.909V507.238a2.915,2.915,0,0,0-2.909-2.915H707.909a2.915,2.915,0,0,0-2.91,2.915Z",
    transform: "translate(-46.41 -54.456)",
    fill: "#009a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M699.545,612.412a3.266,3.266,0,0,0,2.568,1.229h179.7a3.307,3.307,0,0,0,3.232-3.985l-2.789-13.25a3.312,3.312,0,0,0-2.059-2.4,3.191,3.191,0,0,0-1.173-.222H704.891a3.2,3.2,0,0,0-1.174.221,3.312,3.312,0,0,0-2.059,2.4l-2.79,13.25a3.305,3.305,0,0,0,.676,2.756Z",
    transform: "translate(-48.402 -25.705)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(829.342 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(818.273 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(807.203 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(796.134 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(785.065 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(773.996 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(762.927 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(751.858 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(740.788 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(729.719 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(718.65 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(707.581 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(696.512 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(685.443 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(674.374 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(663.304 573.785) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(829.473 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(818.404 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(807.334 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(796.265 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_21",
    "data-name": "Rectangle 21",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(785.196 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(774.127 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(763.058 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24",
    "data-name": "Rectangle 24",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(751.988 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(740.919 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(729.85 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(718.781 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(707.712 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(696.642 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(685.573 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(674.504 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 5.535,
    height: 3.321,
    rx: 0.488,
    transform: "translate(663.435 579.319) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 44.277,
    height: 3.321,
    rx: 0.488,
    transform: "translate(776.341 585.961) rotate(180)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(681.346 474.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(724.321 474.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(736.498 474.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(693.035 473.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(750.335 473.685)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(692.806 483.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(735.781 483.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(747.958 483.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(704.495 482.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(761.795 482.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(704.266 492.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(747.242 492.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(759.418 492.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(715.955 492.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(773.256 492.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(715.725 501.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(758.701 501.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(770.877 501.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(727.416 501.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(724.321 538.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(736.498 538.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(750.335 539.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(681.346 538.989)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(693.035 539.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(692.806 529.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(735.781 529.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(747.958 529.677)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(704.495 530.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(704.266 520.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(747.242 520.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(759.418 520.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(715.955 520.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(715.725 511.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(758.701 511.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 7.883,
    height: 4.126,
    rx: 1.561,
    transform: "translate(770.877 511.055)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 27.48,
    height: 4.126,
    rx: 1.561,
    transform: "translate(727.416 511.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M715.8,680.06l-17.64-27.883,55.369-44.138L776.38,582.72a25.319,25.319,0,0,1,42.836,9.022h0a25.319,25.319,0,0,1-15.289,31.7L767.79,636.757Z",
    transform: "translate(-48.609 -31.946)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M398.28,502.464V637.985h94.941V502.464a4.556,4.556,0,0,0-3.211-4.361,4.2,4.2,0,0,0-1.361-.211H402.865A4.576,4.576,0,0,0,398.28,502.464Zm37.052,46.565a10.135,10.135,0,1,1,20.27,0v15.725a10.135,10.135,0,1,1-20.27,0Z",
    transform: "translate(-144.984 -56.523)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M398.06,600.632V613.7a2.572,2.572,0,0,0,2.55,2.564h90.422a2.563,2.563,0,0,0,2.55-2.564V600.632Z",
    transform: "translate(-145.055 -23.504)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M285.25,349.721V597.163a11.9,11.9,0,0,0,11.892,11.892H663.826a11.9,11.9,0,0,0,11.892-11.892V349.721a11.908,11.908,0,0,0-11.892-11.879H297.142A11.908,11.908,0,0,0,285.25,349.721Z",
    transform: "translate(-181.31 -107.96)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M291.76,350.711V592.022a6.367,6.367,0,0,0,6.356,6.356H658.682a6.367,6.367,0,0,0,6.356-6.356V350.711a6.369,6.369,0,0,0-6.355-6.369H298.116A6.37,6.37,0,0,0,291.76,350.711Z",
    transform: "translate(-179.218 -105.871)",
    fill: "#ababab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M342.616,617.2a3.9,3.9,0,0,0,3.066,1.466H560.195a3.947,3.947,0,0,0,3.858-4.757l-3.33-15.817a3.954,3.954,0,0,0-2.458-2.867,3.828,3.828,0,0,0-1.4-.264H349a3.819,3.819,0,0,0-1.4.264,3.955,3.955,0,0,0-2.458,2.867l-3.33,15.817A3.945,3.945,0,0,0,342.616,617.2Z",
    transform: "translate(-163.159 -25.326)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M642.968,370.152H305.587a1.342,1.342,0,1,1,0-2.684H642.968a1.342,1.342,0,1,1,0,2.684Z",
    transform: "translate(-175.205 -98.439)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 7.863,
    cy: 8.038,
    rx: 7.863,
    ry: 8.038,
    transform: "translate(145.485 246.103)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 7.863,
    cy: 8.038,
    rx: 7.863,
    ry: 8.038,
    transform: "translate(172.647 246.103)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 7.863,
    cy: 8.038,
    rx: 7.863,
    ry: 8.038,
    transform: "translate(199.81 246.103)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M553.245,351.622H533.953a1.461,1.461,0,0,0,0,2.92h19.292a1.46,1.46,0,1,0,0-2.921Z",
    transform: "translate(-101.84 -103.531)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M553.253,355.772H533.961a1.46,1.46,0,1,0,0,2.921h19.292a1.46,1.46,0,1,0,0-2.92Z",
    transform: "translate(-101.848 -102.198)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M553.245,359.922H533.953a1.461,1.461,0,0,0,0,2.92h19.292a1.46,1.46,0,1,0,0-2.92Z",
    transform: "translate(-101.84 -100.864)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M902.566,624.725a8.478,8.478,0,0,0,8.17,5.723l35.006-.9a8.362,8.362,0,0,0,7.9-6.154l4.954-52.97a12.94,12.94,0,0,0,5.6,1.151,12.766,12.766,0,0,0-.641-25.524,10.805,10.805,0,0,0-2.294.238,8.651,8.651,0,0,0-6.44-2.779l-53.847,1.39a7.752,7.752,0,0,0-1.328.165,8.41,8.41,0,0,0-6.439,10.921Zm57.049-57.9L963.14,554.2a8.6,8.6,0,0,0,.027-4.459c.171,0,.322-.081.493-.082a9.131,9.131,0,0,1,.427,18.258,8.6,8.6,0,0,1-4.473-1.093Z",
    transform: "translate(13.939 -41.862)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M897.978,545.065c1.147,6.559,14.045,11.171,29.554,10.369,14.261-.657,25.922-5.665,28.058-11.6a7.971,7.971,0,0,0-2.437-.325L899.307,544.9A7.707,7.707,0,0,0,897.978,545.065Z",
    transform: "translate(15.61 -41.863)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M922.767,585.729a.663.663,0,0,0,.2-.088l7.6-4.976a.66.66,0,0,0,0-1.105l-7.9-5.175a.66.66,0,1,0-.724,1.1L929,580.112l-6.758,4.424a.66.66,0,0,0,.523,1.193Z",
    transform: "translate(23.216 -31.974)",
    fill: "#009a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M915.525,586.148a.661.661,0,0,0,.167-1.213l-7.007-4.018,6.773-5.031a.66.66,0,1,0-.788-1.06l-7.583,5.632a.659.659,0,0,0,.065,1.1l7.883,4.519A.657.657,0,0,0,915.525,586.148Z",
    transform: "translate(18.452 -31.839)",
    fill: "#009a93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M924.743,590.87a.634.634,0,0,0,.181-.076.661.661,0,0,0,.221-.908l-10.776-17.717a.661.661,0,1,0-1.129.688l10.776,17.718A.661.661,0,0,0,924.743,590.87Z",
    transform: "translate(20.484 -32.754)",
    fill: "#009a93"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 67.019,
    height: 14.331,
    rx: 3.264,
    transform: "translate(276.678 344.652)",
    fill: "#009a93"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 135.093,
    height: 14.331,
    rx: 3.264,
    transform: "translate(242.64 373.316)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 135.093,
    height: 14.331,
    rx: 3.264,
    transform: "translate(242.64 401.978)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M497.3,558.572l.286.9.015.03,8.622,26.214,9.919,30.208L534.8,672.7l.181,8.818v.03l1.387,70.938-3.844,9.617,4.326,15.767s-1.99-23.834-12.662-10.146c-6.044,7.778-13.114,15.737-18.918,23.2q12.685,5.133,25.776,9.285c1.884.6,3.784,1.176,5.683,1.749l1.221.362a352.623,352.623,0,0,0,89,14.305c1.567.045,3.105.075,4.6.105.528.015,1.04.03,1.552.03,1.688.015,3.362.03,5.05.03q5.11,0,10.175-.151a352.6,352.6,0,0,0,74.118-10.024c-.166-10.024-.618-21.737-1.266-34.248-.3-6.135-7.07-12.783-7.477-19.2-.286-4.824,5.788-9.361,5.472-14.26-2.05-30.163-4.613-18.584-6.512-39.944q-.294-3.143-.543-6.014c-1.221-13.717-2.065-22.295-2.065-22.295l8.11-51.115L730.9,539.277l-.98-1.613-1.1-.543-67.184-33.253-3.648-9.346a14.508,14.508,0,0,0-13.4-9.18l-44.257-.181a14.444,14.444,0,0,0-11.773,5.984l-11.984,16.6Z",
    transform: "translate(-113.161 -60.614)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M556.262,647.555l-10.025,21.45-6.844,14.652-11.772,61.637-5.894,6.255L516.678,729.4,463.825,741.14c-1.733-9.632-.464.326-1.534-10.241.3-.3.618-.6.935-.9.844-.784,1.553-1.523,1.537-2.231-.6-36.448,1.206-98.478,16.31-136.057a79.361,79.361,0,0,1,9.285-17.32c.3-.407.588-.814.874-1.221,6.964-9.753,11.366-19.355,17.606-26.183v-.015a.692.692,0,0,0,.106-.106.2.2,0,0,0,.06-.045l42.87-22.731,1.839,51.673,1.311,37.142Z",
    transform: "translate(-124.412 -48.105)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M650.391,653.519l12.522,26.791,4.37,9.33,11.769,61.631,5.875,6.241,5.061-22.14,2.378-.488L735.256,726l12.5,39.7a23.764,23.764,0,0,0-4.309-29.739c-.854-.772-1.565-1.525-1.545-2.236.711-42.87-1.911-121.149-25.592-153.368-7.521-10.224-12.034-20.408-18.6-27.523-.021-.02-.021-.041-.041-.041l-15.977-26.16-.976-1.606-1.1-.549Z",
    transform: "translate(-63.96 -47.977)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 58.879,
    cy: 58.879,
    r: 58.879,
    transform: "translate(451.7 294.196)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M688.672,411.068a4.968,4.968,0,0,0-3.555-1.573l.886-2.458a4.662,4.662,0,0,0-5.233-6.211l-3.224.621.3-2.154a4.67,4.67,0,0,0-6.25-5.048,4.977,4.977,0,0,1-4.281-.3,5.083,5.083,0,0,1-2.537-3.449l-1.123-5.418-.119-.291c-5.47-9.118-15.989-15.751-28.859-18.182-11.457-2.18-23.2-1.07-34.528-.026-4.493.423-9.567.9-13.8,3.488-3.594,2.22-6.633,6.66-6.012,11.139-11.166-3.422-23.137,3.409-29.07,12.025-7.03,10.254-8.18,23.1-8.364,33.14-.5,23.759,4.4,43.2,14.535,57.784.74,1.057.925,3.264,2.392,4l-.3-.489c1.639.819,3.3,2.141,2.682,3.555-1.784,4.07,10.069,13.069,18.42,16.042,15.236,5.431,35.492,4.968,49.737,3.013l.5-3.37c5.14-.7,8.761-2.035,9.778-4.123,1.8-1.533,3.33-2.907,4.665-4.176l.013-.013c.027-.027.079-.066.106-.093,6.435-6.171,7.928-9.686,8.6-15.037.647-5.246-.5-10.571-1.678-15.368,24.763,3.832-9.752-26.375,13.319-32.215a7.166,7.166,0,0,1,.806-.2c.674-.159,1.348-.317,2-.5a34.946,34.946,0,0,0,8.88-3.792c6.448-3.924,8.576-9.131,11.906-15A4.527,4.527,0,0,0,688.672,411.068Z",
    transform: "translate(-98.514 -99.12)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M844.879,645.965c-.013,2.312-.04,5.55-.146,9.554q-.02.832-.04,1.7c-.172,7.36-.344,13.531-.621,20.389-.013.475-.026.938-.053,1.414-.37,9.567-.951,20.706-1.955,38.346-1.863,32.585-5.114,4.48-8.378,15.91-.158.568-.33,1.242-.489,2.035a36.876,36.876,0,0,1-2.484,8.365c-1.731,1.031-3.515,2.022-5.272,3.013-5.008,2.788-10.1,5.47-15.222,8.021-2.881,1.427-5.774,2.828-8.682,4.176-.462.211-.912.423-1.361.621a357.948,357.948,0,0,1-45.918,17.521c-3.066.925-6.118,1.824-9.21,2.656-3.224.9-6.448,1.744-9.712,2.537a352.641,352.641,0,0,1-74.116,10.029c-3.37.106-6.766.146-10.175.146-1.691,0-3.356-.013-5.048-.027-.515,0-1.031-.013-1.546-.026-1.493-.04-3.039-.066-4.6-.106a352.387,352.387,0,0,1-89-14.311l-1.229-.357c-1.9-.582-3.792-1.15-5.682-1.758q-13.082-4.143-25.78-9.276-9.692-3.9-19.16-8.378a.447.447,0,0,1-.158-.079c-1.321-.608-2.656-1.242-3.977-1.89-.172-.093-.357-.185-.542-.277q-7.393-3.607-14.628-7.559c-4.057-9.316-9.765-11.1-13.306-19.292a34.172,34.172,0,0,1-2.22-7.585c0-.026-.013-.053-.013-.093.37,4.916-1.572-8.721-.013-.053-.013-.159-.026-.33-.04-.529-.04-.476-.092-1.057-.172-1.784-4.532-44.253-4.242-94.862-6.21-136.565q-.2-4.044-.41-7.744c-.04-.819-.092-1.625-.145-2.418.093-.238.2-.489.317-.727a1.325,1.325,0,0,1,.093-.2,2.134,2.134,0,0,1,.132-.238c.026-.04.066-.093.093-.132a1.158,1.158,0,0,1,.066-.132c.119-.185.251-.383.4-.568.066-.079.119-.146.185-.211a1.05,1.05,0,0,1,.159-.185.838.838,0,0,1,.145-.172c.053-.053.106-.119.172-.185a.4.4,0,0,1,.106-.106,2.678,2.678,0,0,1,.344-.33,12.726,12.726,0,0,1,1.506-1.189c.185-.119.383-.237.568-.37a25.277,25.277,0,0,1,4.189-2.009c.5-.185,1-.357,1.546-.542.2-.053.383-.119.581-.185.291-.093.581-.185.885-.251,1.506-.449,3.132-.832,4.889-1.189.211-.04.436-.079.661-.132.317-.066.647-.119.978-.172.449-.079.912-.158,1.374-.238,3.924-.621,8.378-1.084,13.293-1.387l1.387-.079,1.639-.079c.462-.026.938-.039,1.414-.053s.938-.04,1.427-.053c1.335-.04,2.709-.079,4.11-.106,3.99-.079,8.193-.053,12.606.04,2.048.053,4.136.106,6.276.2.145,0,.277.013.41.013,1.863.066,3.739.145,5.669.251,1.348.066,2.709.132,4.07.211,1.282.079,2.577.158,3.885.251,1.017.053,2.035.132,3.066.2.872.066,1.744.132,2.616.185l1.189.079c.648.053,1.3.092,1.956.158,1.454.119,2.907.238,4.387.357s2.96.264,4.453.4,3,.278,4.506.422l.449.04c1.374.146,2.749.277,4.136.423.317.026.647.053.964.093,1.323.133,2.672.288,4.007.43l1.228.132c1.046.114,2.076.213,3.13.336,1.387.158,2.8.3,4.175.489,1.07.119,2.141.238,3.211.37,1.678.2,3.383.41,5.087.634.648.079,1.295.158,1.942.251,4.863.608,9.778,1.282,14.773,1.982,7.572,1.07,15.262,2.233,23.005,3.489s15.557,2.581,23.4,3.977c1.982.357,3.964.714,5.96,1.083l2.7.515c1.533.278,3.066.568,4.6.859s3.065.582,4.6.885l5.484,1.07c12.011,2.378,23.957,4.916,35.611,7.572,1.916.436,3.832.885,5.735,1.321q5.708,1.328,11.311,2.7c1.031.238,2.048.489,3.066.74,2.537.634,5.074,1.268,7.571,1.916l.436.119c1.837.449,3.634.912,5.431,1.388q6.363,1.665,12.513,3.37,4.083,1.13,8.074,2.286c3.978,1.15,7.875,2.312,11.668,3.489.938.291,1.876.581,2.8.859,2.775.859,5.51,1.731,8.166,2.6,2.114.687,4.175,1.388,6.21,2.088s4.03,1.4,5.986,2.1c1.255.449,2.5.925,3.74,1.374,1.784.661,3.542,1.321,5.259,1.982.529.2,1.044.41,1.559.608.33.145.647.264.964.4.621.251,1.255.489,1.863.74s1.229.489,1.837.753c.594.238,1.2.489,1.784.74s1.176.489,1.757.753c.489.2.965.41,1.427.621.938.41,1.876.819,2.788,1.242.449.212.9.41,1.348.621l1.031.476c.145.079.291.145.436.211.33.159.674.33,1,.489.766.357,1.52.74,2.26,1.1.991.5,1.956,1,2.881,1.493s1.85,1,2.722,1.493c.145.079.277.159.423.238.2.106.4.225.595.33.674.383,1.322.78,1.969,1.163,1.269.779,2.471,1.546,3.594,2.312.251.172.489.344.74.5.833.595,1.625,1.176,2.365,1.771,0,.013,0,.013.013.013.251.185.489.383.727.568.2.185.41.344.608.529.687.595,1.321,1.162,1.9,1.744a7.469,7.469,0,0,1,.555.568,1.575,1.575,0,0,1,.212.212c.264.264.5.529.727.793a.7.7,0,0,1,.093.119c.317.37.608.74.885,1.11.132.185.278.37.4.555.158.225.317.463.449.687.119.185.224.383.33.568a9.615,9.615,0,0,1,.714,1.493,6.93,6.93,0,0,1,.357,1.083A7.793,7.793,0,0,1,844.879,645.965Z",
    transform: "translate(-126.058 -36.23)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M844.882,645.963c-.013,2.313-.04,5.55-.146,9.554-.013.555-.04,1.123-.053,1.7-.132,5.616-.33,12.553-.608,20.389-.013.475-.026.938-.053,1.414-.37,9.567-.951,20.706-1.956,38.347-1.863,32.585-5.114,4.479-8.377,15.909-9.065-5.576-19-11.417-29.626-17.416q-2.874-1.625-5.8-3.264c-21.248-11.853-44.98-24.274-69.756-36.576-.978-.489-1.969-.978-2.947-1.454-56.753-28.053-118.7-55.339-168.886-73.548-9.686-3.515-18.936-6.686-27.63-9.474-18.314-5.854-34.144-9.95-46.328-11.721-12.685-1.85-21.446-1.189-24.987,2.63q-.2-4.043-.41-7.743-.079-1.229-.159-2.418c.081-.217.187-.425.29-.634.015-.031.025-.062.04-.092a1.332,1.332,0,0,1,.092-.2,2.2,2.2,0,0,1,.132-.238,1.41,1.41,0,0,1,.159-.264c.119-.185.251-.383.4-.568a4.652,4.652,0,0,1,.344-.4.847.847,0,0,1,.145-.172c.053-.053.106-.119.172-.185a.406.406,0,0,1,.106-.106,2.688,2.688,0,0,1,.344-.33,12.738,12.738,0,0,1,1.506-1.189c.185-.119.383-.238.568-.37a25.242,25.242,0,0,1,4.189-2.008c.5-.185,1-.357,1.546-.542.2-.053.383-.119.581-.185.291-.093.581-.185.885-.251,1.506-.449,3.132-.832,4.889-1.189.528-.106,1.084-.212,1.639-.3.449-.079.912-.159,1.374-.238,3.925-.621,8.377-1.083,13.293-1.387l1.387-.079,1.638-.079c.463-.026.938-.04,1.414-.053s.938-.04,1.427-.053c1.335-.04,2.709-.079,4.109-.106,3.99-.066,8.193-.04,12.606.053,2.048.04,4.136.106,6.276.2.132,0,.278.013.41.013,1.863.053,3.753.145,5.669.238,1.348.066,2.709.132,4.07.211,1.282.079,2.577.159,3.885.251,1.017.052,2.035.132,3.066.2.872.066,1.744.132,2.616.185l3.145.238c1.453.119,2.907.238,4.387.357s2.96.264,4.453.4,3,.278,4.506.423l.449.04c1.374.145,2.749.278,4.136.423q11.536,1.17,23.745,2.735,7.294.932,14.773,2c7.572,1.07,15.262,2.233,23.005,3.475s15.557,2.581,23.4,3.977c1.982.357,3.964.714,5.959,1.084q3.647.674,7.294,1.374c1.533.291,3.065.581,4.6.885,1.823.357,3.66.714,5.484,1.071,12.011,2.378,23.957,4.915,35.611,7.572,1.916.436,3.832.885,5.735,1.321q5.708,1.328,11.311,2.7c1.03.251,2.048.5,3.065.753q3.826.951,7.572,1.9v.013c.146.026.291.066.436.106,1.824.463,3.634.925,5.431,1.4q6.363,1.665,12.513,3.356c2.722.766,5.418,1.52,8.074,2.286,3.977,1.163,7.875,2.326,11.668,3.488.938.291,1.876.581,2.8.859q4.163,1.308,8.166,2.6c2.114.687,4.176,1.387,6.211,2.087s4.03,1.4,5.986,2.1c1.269.449,2.51.912,3.74,1.361,1.8.661,3.541,1.322,5.259,2,.529.2,1.044.41,1.559.608.964.37,1.9.753,2.828,1.137.621.238,1.229.489,1.837.753.595.238,1.2.489,1.784.74s1.176.489,1.757.753c.489.2.964.41,1.427.621.938.41,1.876.82,2.788,1.242.45.211.9.409,1.348.621l1.031.476c.146.079.291.145.436.211,1.123.529,2.207,1.057,3.264,1.586.991.5,1.956,1,2.881,1.493,1.1.582,2.141,1.15,3.145,1.731.2.106.4.225.595.33.674.383,1.322.78,1.969,1.163,1.269.779,2.471,1.546,3.594,2.312s2.141,1.52,3.1,2.273c0,.013,0,.013.013.013.463.37.912.74,1.335,1.1.687.595,1.321,1.163,1.9,1.744a7.474,7.474,0,0,1,.555.568,1.608,1.608,0,0,1,.211.212c.278.3.555.608.819.912.317.37.608.74.885,1.11.132.185.278.37.4.555.159.224.317.463.45.687.119.185.225.383.33.568a9.6,9.6,0,0,1,.713,1.493,7.98,7.98,0,0,1,.357,1.084A7.7,7.7,0,0,1,844.882,645.963Z",
    transform: "translate(-126.061 -36.228)",
    opacity: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawProgrammingReKg9V);
export default __webpack_public_path__ + "static/media/undraw_programming_re_kg9v.a646dbaf.svg";
export { ForwardRef as ReactComponent };